import { render, staticRenderFns } from "./MunicipalityList.vue?vue&type=template&id=55857d22&scoped=true&"
import script from "./MunicipalityList.vue?vue&type=script&lang=js&"
export * from "./MunicipalityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55857d22",
  null
  
)

export default component.exports